<template>
  <div class="sheet-panel user-persona">
    <div class="sheet-header">
      <h3>{{ firstName }} {{ lastName }}</h3>
      <router-link
        to="/test/personality"
        class="icon-link card-link"
        title="Re-take test"
        v-tippy
        >
        <font-awesome-icon icon="redo" />
        </router-link
      >
      <router-link
        to="/profile"
        class="icon-link card-link"
        title="Share profile"
        v-tippy
        >
        <font-awesome-icon icon="share-alt" />
        </router-link
      >
    </div>
    <div class="sheet-content">
      <img
        :src="
          'https://cdn.traitstack.com/static/' +
            personas[personality.persona].image
        "
        class="persona-image"
      />
      <div class="h3 blue text-center">
        {{ personas[personality.persona].title }}
      </div>
      <div class="tags text-center">
        <div
          class="tag"
          v-bind:key="tag"
          v-for="tag in personas[personality.persona].tags"
        >
          {{ tag }}
        </div>
      </div>
      <p>
        {{ personas[personality.persona].description }}
      </p>
    </div>
  </div>
</template>
<script>
import { personas, reporting } from "@/assets/static.js";
export default {
  props: {
    firstName: String,
    lastName: String,
    personality: Object,
  },
  data() {
    return {
      personas: personas,
      reporting: reporting,
    };
  },
  methods: {},
};
</script>
